"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.TAG_INPUT_ERROR = exports.TAG_INPUT = exports.TAG = exports.DISABLED_TAG_INPUT_CONTAINER = exports.TAG_INPUT_CONTAINER = exports.SELECTED_TAG_INPUT_CONTAINER = exports.INPUT_STYLES = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Input = require("../../../common/styles/Input"),
    _vars = require("../../../common/styles/vars"),
    INPUT_STYLES = function INPUT_STYLES(a) {
  var b = a.valid,
      c = a.disabled;
  return (0, _Input.INPUT)({
    disabled: c,
    valid: b,
    hasSuffix: !b
  });
};

exports.INPUT_STYLES = INPUT_STYLES;
var SELECTED_TAG_INPUT_CONTAINER = (0, _cxs["default"])({
  borderColor: "".concat(_vars.COLOURS.cyan.turquoise, " !important")
});
exports.SELECTED_TAG_INPUT_CONTAINER = SELECTED_TAG_INPUT_CONTAINER;

var TAG_INPUT_CONTAINER = function TAG_INPUT_CONTAINER(a) {
  var b = a.valid,
      c = a.disabled;
  return (0, _classnames["default"])(INPUT_STYLES({
    valid: b,
    disabled: c
  }), (0, _cxs["default"])({
    padding: "0 20px",
    display: "flex",
    alignItems: "center",
    overflowY: "auto",
    flexFlow: "row wrap",
    position: "relative",
    textOverflow: "ellipsis",
    maxHeight: "180px",
    background: _vars.COLOURS.mono.white,
    height: "fit-content",
    borderWidth: "1px",
    borderRadius: "4px !important",
    " > div": {
      display: "inline-flex",
      overflow: "hidden"
    }
  }));
};

exports.TAG_INPUT_CONTAINER = TAG_INPUT_CONTAINER;
var DISABLED_TAG_INPUT_CONTAINER = (0, _classnames["default"])(INPUT_STYLES, (0, _cxs["default"])({
  background: _vars.COLOURS.grey.athens.zeus
}));
exports.DISABLED_TAG_INPUT_CONTAINER = DISABLED_TAG_INPUT_CONTAINER;
var TAG = (0, _cxs["default"])({
  margin: "6px 5px 6px 5px"
});
exports.TAG = TAG;
var TAG_INPUT = (0, _cxs["default"])({
  background: "transparent",
  border: 0,
  outline: "none",
  color: "inherit",
  caretColor: "inherit",
  fontSize: "inherit",
  display: "inline-flex",
  flex: "auto",
  padding: "7px",
  lineHeight: "1.25px"
});
exports.TAG_INPUT = TAG_INPUT;
var TAG_INPUT_ERROR = (0, _cxs["default"])({
  position: "absolute",
  right: "20px",
  color: _vars.COLOURS.red.thunderBird,
  fontSize: _vars.FONT_SIZES.small,
  fontWeight: _vars.FONT_WEIGHTS.medium
});
exports.TAG_INPUT_ERROR = TAG_INPUT_ERROR;